import { render, staticRenderFns } from "./chinh-sach-bao-ve.vue?vue&type=template&id=9793cb44&"
import script from "./chinh-sach-bao-ve.vue?vue&type=script&lang=js&"
export * from "./chinh-sach-bao-ve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports